import { render, staticRenderFns } from "./ComplaintReportContainer.vue?vue&type=template&id=640ff1cb&"
import script from "./ComplaintReportContainer.vue?vue&type=script&lang=js&"
export * from "./ComplaintReportContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports